import { InitialState } from "../Interfaces";

export const initialState: InitialState = {
  assignedDocumentsList: {
    data: [],
    isLoading: false,
  },
  assignedDocumentContent: {
    data: "",
    isFetching: false,
  },
};
